// extracted by mini-css-extract-plugin
export var measureBox = "_dk-0";